var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sku-select" },
    [
      _c(
        "el-button",
        {
          staticStyle: { "margin-bottom": "20px" },
          attrs: { size: "mini", type: "primary" },
          on: {
            click: function ($event) {
              return _vm.openInit()
            },
          },
        },
        [_vm._v("选择商品")]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: "选择商品",
            top: "100px",
            width: "80vw",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  staticStyle: { "margin-top": "20px" },
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: "",
                        size: "small",
                        "label-width": "120px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品分类" } },
                        [
                          _c("el-cascader", {
                            staticClass: "selWidth mr20",
                            attrs: {
                              options: _vm.merCateList,
                              props: _vm.props,
                              clearable: "",
                              size: "small",
                            },
                            on: { change: _vm.handerSearch },
                            model: {
                              value: _vm.listPram.cateId,
                              callback: function ($$v) {
                                _vm.$set(_vm.listPram, "cateId", $$v)
                              },
                              expression: "listPram.cateId",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "名称" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth mr20",
                              attrs: {
                                placeholder: "名称",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.skuName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "skuName", $$v)
                                },
                                expression: "listPram.skuName",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.handerSearch },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "SKU编码" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth mr20",
                              attrs: {
                                placeholder: "SKU编码",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.skuCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "skuCode", $$v)
                                },
                                expression: "listPram.skuCode",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.handerSearch },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  ref: "tableListRef",
                  staticClass: "table",
                  attrs: {
                    data: _vm.listData.list,
                    size: "mini",
                    height: "500",
                    "highlight-current-row": "",
                    "header-cell-style": { fontWeight: "bold" },
                  },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "55" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "id", label: "ID", "min-width": "50" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "skuCode",
                      label: "编码",
                      "min-width": "150",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "skuName",
                      label: "名称",
                      "min-width": "180",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "price",
                      label: "零售价",
                      "min-width": "180",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "listStatus",
                      label: "状态",
                      "min-width": "180",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return _c("div", {}, [
                            _vm._v(
                              _vm._s(
                                { 0: "未上架", 1: "已上架" }[
                                  scope.row.listStatus
                                ]
                              )
                            ),
                          ])
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "brandName",
                      label: "品牌",
                      "min-width": "180",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "supplierName",
                      label: "供应商",
                      "min-width": "180",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.listPram.page,
                  "page-sizes": _vm.constants.page.limit,
                  layout: _vm.constants.page.layout,
                  total: _vm.listData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: !_vm.selectIds || !_vm.selectIds.length,
                  },
                  on: { click: _vm.handerSubmit },
                },
                [_vm._v("确认调整")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }